import $ from 'jquery';
import 'bootstrap';
require('waypoints/lib/noframework.waypoints.js');
import Swiper, {SwiperOptions, Autoplay, Pagination, Navigation, Keyboard} from "swiper"
Swiper.use([Autoplay, Pagination, Navigation, Keyboard]);

import {TweenMax, gsap, ScrollToPlugin, ScrollTrigger, TimelineMax} from "gsap/all";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

// MATCH WINDOWS SIZE FUNCTION
function installMediaQueryWatcher(mediaQuery, layoutChangedCallback) {
    var mql = window.matchMedia(mediaQuery);
    mql.addListener(function (e) { return layoutChangedCallback(e.matches); });
    layoutChangedCallback(mql.matches);
}


const general = {
    
    "mqBreakpoints": {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1156
    },

    
    "videoPlayer": function() {
        //$('#homepage-video').get(0).play();

        $(".js-audio-mute").click(function () {
            $('#homepage-video').prop("muted", !$('#homepage-video').prop("muted"));
            
            if($(this).hasClass('active')){
                $(this).removeClass("active");
            } else {
                $(this).addClass("active");
            }
        });

        $(".js-video-play").click(function () {            
            if($(this).hasClass('active')){
                $(this).removeClass("active");
                $('#homepage-video').get(0).pause();
                $('.js-audio-mute').addClass('no-animate');
            } else {
                $(this).addClass("active");
                $('#homepage-video').get(0).play();
                $('.js-audio-mute').removeClass('no-animate');
            }
        });

        $('.js-video-skip').click(function(){
            $('#homepage-video').trigger('ended')[0].pause();
        });

        $(document).keyup(function(e) {
            if($('#homepage-video').length) {
                if (e.keyCode === 27) {
                    $('#homepage-video').trigger('ended')[0].pause();
                }
            }
        });
    },
    
    "homeLoader": function() {
        if ($('.home .loader').length) {
            setTimeout(function() {
                $('.loader__phase.--one').toggleClass('show')
                $('.loader__logo').toggleClass('show')
                $('body').css('overflow', 'hidden');
            }, 0);

            setTimeout(function() {
                $('.loader__phase.--one').toggleClass('show')
            }, 2000);

            setTimeout(function() {
                $('.loader__phase.--two').toggleClass('show')
            }, 3250);

            setTimeout(function() {
                $('.loader__phase.--two').toggleClass('show')
                gsap.to('.loader__logo', {y:60, duration: .5, ease: "slow(0.7, 0.7, false)", delay: 1.3});
            }, 15000);

            $('#homepage-video').on('ended',function(){
                $('.loader').toggleClass('hidden');

                setTimeout(function() {
                    $('.loader').toggleClass('d-none');
                    $('body').css('overflow-y', 'auto');
                }, 2000);
            });
        }
    },

    
    "showAnim": function() {
            
        // HOMEPAGE - GENERAL ANIMATION
        if($('.home .loader').length) {
            $('#homepage-video').on('ended',function(){
                setTimeout(function() {
                    gsap.to('.navbar', {autoAlpha: 1, duration: .3});
                    gsap.fromTo('.-home h1', {autoAlpha: 0, y:20}, {autoAlpha: 1, y:0, duration: .9, delay: .6});
                    gsap.fromTo('.-home .size-large', {autoAlpha: 0}, {autoAlpha: 1, duration: .9, delay: .9});
                    gsap.fromTo('.home .lang-switcher', {autoAlpha: 0}, {autoAlpha: 1, duration: .9, delay: .9});
                }, 2100); 
            });
        } else if($('.home').length) {
            setTimeout(function() {
                gsap.to('.navbar', {autoAlpha: 1, duration: .3});
                gsap.fromTo('.-home h1', {autoAlpha: 0, y:20}, {autoAlpha: 1, y:0, duration: .9, delay: .6});
                gsap.fromTo('.-home .size-large', {autoAlpha: 0}, {autoAlpha: 1, duration: .9, delay: .9});
                gsap.fromTo('.home .lang-switcher', {autoAlpha: 0}, {autoAlpha: 1, duration: .9, delay: .9});
            }, 100); 
        }

        // HOMEPAGE - SWIPER ANIMATION
        if($('.swiper-home').length) {
            let swiperHomeTL = gsap.timeline({paused:true});
            swiperHomeTL.fromTo('.swiper-home h3', 0.75, {opacity:0, y: 20}, {opacity:1, y:0}); 
            swiperHomeTL.staggerFromTo('.swiper-home .swiper-slide', 0.75, {opacity:0, y: 20}, {opacity:1, y:0}, 0.15, .6); 

            ScrollTrigger.create({
                trigger: '.swiper-home',
                start: () => 'top bottom-=400px',
            
                onEnter: function() {
                    swiperHomeTL.play();
                },
            })
        }
        
        // BASIC PAGE - ANIMATION
        if($('.-basic-page').length) {
            gsap.fromTo('.-basic-page h1', {autoAlpha: 0, y:20}, {autoAlpha: 1, y:0});

            if(!$('.-basic-page').hasClass('-about-page')) {
                gsap.fromTo('.-basic-page .basic-header', {autoAlpha: 0, y:20}, {autoAlpha: 1, y:0, duration: .9, delay:.3 });
            }

            if($('.-basic-page .size-large').length) {
                gsap.fromTo('.-basic-page .size-large', {autoAlpha: 0}, {autoAlpha: 1, duration: .9, delay: .6});
            }
        }
        
        // PORTFOLIO - TABS ANIMATION
        if($('.tabcontent').length){
            var navTabTL = gsap.timeline({onComplete:showPanel});
            navTabTL.staggerFromTo('.nav-tabs li', 0.75, {opacity:0, y: 20}, {opacity:1, y:0}, 0.15, .9); 
    
            function showPanel(){
                gsap.fromTo('.-basic-page .tabcontent', {autoAlpha: 0}, {autoAlpha: 1});
            }
        }
       
        // PORTFOLIO - CONTENT ANIMATION (DESKTOP)
        installMediaQueryWatcher("(min-width: 576px)", function(matches) {
            if (matches) {
                if($('.folio-container').length) {
                    let folioCTATL = gsap.timeline({paused:true});
                    folioCTATL.fromTo('.folio-container h3', 0.75, {opacity:0, y: 20}, {opacity:1, y:0}); 
                    folioCTATL.fromTo('.folio-container .folio-columns', 0.75, {opacity:0}, {opacity:1}, 0.6); 

                    ScrollTrigger.create({
                        trigger: '.folio-container',
                        start: () => 'top bottom-=400px',
                    
                        onEnter: function() {
                            folioCTATL.play();
                        },
                    })
                }
            }
        });

        // PORTFOLIO - SWIPER ANIMATION
        const folioSwipeBoxes = gsap.utils.toArray('.swiper-portfolio .swiper-wrapper');
        folioSwipeBoxes.forEach(folioswiper => {
            var folioSwip = folioswiper.querySelectorAll(".swiper-slide");

            let folioswipeO = gsap.timeline({
                scrollTrigger: {
                trigger: folioswiper,
                start: "top bottom-=300px", // when the top of the trigger hits the bottom - 300px of the viewport
                }
            });
            
            if($(folioSwipeBoxes).length){
                folioswipeO.staggerFromTo(folioSwip, 0.75, {opacity:0, y: 20}, {opacity:1, y:0}, 0.15); 
            }
        });
            
        // ABOUT PAGE - TIMELINE NAV ANIMATION
        if($('.timeline-header-container').length) {
            let timelineHeaderTL = gsap.timeline({paused:true});
            timelineHeaderTL.fromTo('.mobile-timeline-nav-container', 0.75, {opacity:0, y: 20}, {opacity:1, y:0}); 
            timelineHeaderTL.staggerFromTo('.timeline-header-container ul li', 0.75, {opacity:0, y: 20}, {opacity:1, y:0}, 0.15, .6); 

            ScrollTrigger.create({
                trigger: '.timeline-header',
                start: () => 'top bottom-=400px',
            
                onEnter: function() {
                    timelineHeaderTL.play();
                },
            })
        } 
 
        // GENERAL IMAGE ANIMATION
        const bgBoxes = gsap.utils.toArray('figure:not(.js-no-animate) img');
        bgBoxes.forEach(bgbox => {
            let bgO = gsap.timeline({
                scrollTrigger: {
                  trigger: bgbox,
                  start: "top bottom-=200px", // when the top of the trigger hits the bottom - 200px of the viewport
                  scrub: "1",  
                }
              });
        
              bgO.from(bgbox, {autoAlpha: 0, scale:1.5}).to(bgbox, {autoAlpha: 1, scale:1});
        });
           
        // GENERAL TEXT ANIMATION
        const textBoxes = gsap.utils.toArray('.wp-block-column');
        textBoxes.forEach(textbox => {
            var textBoxesTitle = textbox.querySelector("h2");
            var textBoxesSubtitle = textbox.querySelector("h3");
            var textBoxesP = textbox.querySelectorAll("p");

            let textO = gsap.timeline({
                scrollTrigger: {
                  trigger: textbox,
                  start: "top bottom-=250px", // when the top of the trigger hits the bottom - 250px of the viewport
                }
            });

            if($(textBoxesTitle).length) {
                textO.fromTo(textBoxesTitle, {autoAlpha: 0, y:20}, {autoAlpha: 1, y:0});
            }

            if($(textBoxesSubtitle).length) {
                textO.fromTo(textBoxesSubtitle, {autoAlpha: 0, y:20}, {autoAlpha: 1, y:0});
            }

            if($(textBoxesP).length) {
                textO.staggerFromTo(textBoxesP, 0.75, {autoAlpha: 0, y:20}, {autoAlpha: 1, y:0}, 0.15);
            }
        });

        // GENERAL TEXT ANIMATION
        const valorBoxes = gsap.utils.toArray('.private-capital');
        valorBoxes.forEach(textbox => {
            var textBoxesTitle = textbox.querySelector("h4");
            var textBoxesP = textbox.querySelectorAll(".valor__icon");

            let textO = gsap.timeline({
                scrollTrigger: {
                    trigger: textbox,
                    start: "top bottom-=250px", // when the top of the trigger hits the bottom - 250px of the viewport
                }
            });

            if($(textBoxesTitle).length) {
                textO.fromTo(textBoxesTitle, {autoAlpha: 0, y:20}, {autoAlpha: 1, y:0});
            }
            if($(textBoxesP).length) {
                textO.fromTo(textBoxesP, {autoAlpha: 0, y:20}, {autoAlpha: 1, y:0});
            }
        });

        //// PROB AFTER PULL
       
            //const folioSwipeBoxes = gsap.utils.toArray('.swiper-portfolio .swiper-wrapper');

        //// JE DOIS COMMENTER LA LIGNE AU DESSUS POUR QUE LE JS COMPILE...

        folioSwipeBoxes.forEach(folioswiper => {
            
            var folioSwip = folioswiper.querySelectorAll(".swiper-slide");
            
            let folioswipeO = gsap.timeline({
                scrollTrigger: {
                  trigger: folioswiper,
                  start: "top bottom-=300px", // when the top of the trigger hits the bottom - 300px of the viewport
                }
              });
           
              
            if($(folioSwipeBoxes).length){
                folioswipeO.staggerFromTo(folioSwip, 0.75, {opacity:0, y: 20}, {opacity:1, y:0}, 0.15); 
            }
            
           
        });
       
        if($('.swiper-home').length) {
            let swiperHomeTL = gsap.timeline({paused:true});
            swiperHomeTL.fromTo('.swiper-home h3', 0.75, {opacity:0, y: 20}, {opacity:1, y:0}); 
            swiperHomeTL.staggerFromTo('.swiper-home .swiper-slide', 0.75, {opacity:0, y: 20}, {opacity:1, y:0}, 0.15, .6); 

            ScrollTrigger.create({
                trigger: '.swiper-home',
                start: () => 'top bottom-=400px',
            
                onEnter: function() {
                    swiperHomeTL.play();
                },
            })
        }
          
        if($('.timeline-header-container').length) {
            let timelineHeaderTL = gsap.timeline({paused:true});
            timelineHeaderTL.fromTo('.mobile-timeline-nav-container', 0.75, {opacity:0, y: 20}, {opacity:1, y:0}); 
            timelineHeaderTL.staggerFromTo('.timeline-header-container ul li', 0.75, {opacity:0, y: 20}, {opacity:1, y:0}, 0.15, .6); 

            ScrollTrigger.create({
                trigger: '.timeline-header',
                start: () => 'top bottom-=400px',
            
                onEnter: function() {
                    timelineHeaderTL.play();
                },
            })
        }
        
        
        installMediaQueryWatcher("(min-width: 576px)", function(matches) {
            if (matches) {
                if($('.folio-container').length) {
                    let folioCTATL = gsap.timeline({paused:true});
                    folioCTATL.fromTo('.folio-container h3', 0.75, {opacity:0, y: 20}, {opacity:1, y:0}); 
                    folioCTATL.fromTo('.folio-container .folio-columns', 0.75, {opacity:0}, {opacity:1}, 0.6); 

                    ScrollTrigger.create({
                        trigger: '.folio-container',
                        start: () => 'top bottom-=400px',
                    
                        onEnter: function() {
                            folioCTATL.play();
                        },
                    })
                }
            }
        });
    },
    

    "menuHandler": function() {
        const navigation = document.querySelector('#mainNavigation');
        const menuWrapper = document.querySelector('#navigationMenu');
        const lis = navigation.querySelectorAll('.navbar-menu > li');
        const navButton = document.querySelector('.navbar');
        let i;
        let len = lis.length;

        $(document).keyup(function(e) {
            if (e.keyCode === 27) {
                navClose();
            }
        });

        $('.bg-nav').click(navClose);

        function navClose(){
            if($('.navbar').hasClass('-menu-open')){
                navigation.classList.remove('animate__fadeInDown');
                navigation.classList.add('animate__fadeOutUp');
                $('.navbar').removeClass('-menu-open');
                $('.navbar-toggler').addClass('collapsed');
                $('.navbar-toggler').attr("aria-expanded", "false");
                $('.navbar-collapse').removeClass('-menu-open animate__fadeInDown');

                setTimeout(function(){ 
                    $('.navbar-collapse').removeClass('animate__fadeOutUp animate__animated show');

                    for (i = 0; i < len; i++) {
                        lis[i].classList.remove('animate__animated', 'animate__fadeInUp');
                    }
                }, 750);

                navButton.ariaExpanded = !JSON.parse(navButton.ariaExpanded);
            } 
        }

        // FX regarding on click menu
        $('#mainNavigation')
            .on('shown.bs.collapse', function () {
                navigation.classList.add('animate__animated', 'animate__fadeIn')
                menuWrapper.classList.add('-menu-open')
            })
            .on('hide.bs.collapse', function () {
                navigation.classList.remove('animate__fadeIn');
                navigation.classList.add('animate__fadeOut');
            }).on('hidden.bs.collapse', function () {
                navigation.classList.remove('animate__animated', 'animate__fadeOut');
                menuWrapper.classList.remove('-menu-open');
                for (i = 0; i < len; i++) {
                    lis[i].classList.remove('animate__animated', 'animate__fadeInUp');
                }
            })
        ;

        // Fx regarding on scrollbar
        let waypointText = new Waypoint({
            element: document.getElementById('js-waypoint'),
            handler: function handler(direction) {
                if (direction === 'down') {
                    document.getElementById('headerBar').classList.add('scroll');
                } else {
                    document.getElementById('headerBar').classList.remove('scroll');
                }
            },
            offset: '-10%'
        });
    },

    "sliderHandler": function () {
        var swiperHomepage = new Swiper('.swiper-home', {
            spaceBetween: 0,
            centeredSlides: true,
            loop: true,
            autoplay: {
                delai: 3000
            },
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
                767: {
                  slidesPerView: 1,
                },
                992: {
                  slidesPerView: 2,
                  centeredSlides: true,
                },
                1200: {
                    slidesPerView: 3,
                  },
              },
        });

        var swiperFolio = new Swiper('.swiper-portfolio', {
            spaceBetween: 0,
            centeredSlides: false,
            slidesPerView: "auto",
            //effect: 'fade',
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    },
    
    "folioTabs": function() {
        // PORTFOLIO TAB NAV ACTIVATION
        function releaseTabLink() {
            $('a[data-toggle="tab"]').css('pointer-events', 'auto');
        }
    
        // PORTFOLIO TAB CONTENT HIDE SWITCH ANIMATION
        $('a[data-toggle="tab"]').on('hide.bs.tab', function (e) {
            var $old_tab = $($(e.target).attr("href"));
            var $new_tab = $($(e.relatedTarget).attr("href"));
            
            $('a[data-toggle="tab"]').css('pointer-events', 'none');

            if($new_tab.index() < $old_tab.index()){
                gsap.fromTo($old_tab, {x:0, opacity:1}, {x:1000, opacity:0, duration: .9, ease: "power2.out", onComplete:releaseTabLink});
                gsap.fromTo($old_tab.find('.img-column'), {x:0}, {x:100, duration: 0.5});
            }
            else {
                gsap.fromTo($old_tab, {x:0, opacity:1}, {x:-1000, opacity:0, duration: .9, ease: "power2.out", onComplete:releaseTabLink});
                gsap.fromTo($old_tab.find('.img-column'), {x:0}, {x:-100, duration: 0.5});
            }
        });

        // PORTFOLIO TAB CONTENT SHOW SWITCH ANIMATION
        $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
            var $new_tab = $($(e.target).attr("href"));
            var $old_tab = $($(e.relatedTarget).attr("href"));

            $new_tab.parent().css('min-height', $new_tab.height() + 'px');

            if($new_tab.index() > $old_tab.index()){
                gsap.fromTo($new_tab, {x:1000, opacity:0}, {x:0, opacity:1, delay: 0.1, duration: .5});
                gsap.fromTo($new_tab.find('.img-column'), {x:100}, {x:0, delay: 0, duration: .25});
            }
            else {
                gsap.fromTo($new_tab, {x:-1000, opacity:0}, {x:0, opacity:1, delay: 0.1, duration: .5});
                gsap.fromTo($new_tab.find('.img-column'), {x:-100}, {x:0, delay: 0, duration: .25});
            }
        });
    
        // PORTFOLIO TAB CONTENT ON ACTIVE ANIMATION
        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            $("a").not(this).removeClass('active');           
            let clickedIndex = 0;

            setTimeout(function() {
                // var swiperFolio = document.querySelector('.tab-panel.active .swiper-portfolio').swiper;
                // var swiperModal = document.querySelector('.tab-panel.active .swiper-modal').swiper;
                //
                // function swiperTabWidth() {
                //     var swiperFolioSpace = $('.tab-panel.active .-portfolio .swiper-container').offset();
                //     var swiperFolioMaxWidth = window.outerWidth - swiperFolioSpace.left;
                //     $('.tab-panel.active .-portfolio .swiper-container').css('max-width', swiperFolioMaxWidth);
                //     swiperFolio.init();
                // }
                // swiperTabWidth();

                window.addEventListener('scroll', () => {
                    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
                });
     
            }, 750);
        });
    },

    "scrollToAnimation": function() {
         $(".-contact-page .--small .btn" ).click(function( event ) {
            event.preventDefault();
            $("html, body").animate({ 
                scrollTop: $('.-contact-page form').offset().top 
            }, 750);
        });

        $(".-about-page .--large .btn" ).click(function( event ) {
            event.preventDefault();
            $("html, body").animate({ 
                scrollTop: $('.timeline-container').offset().top 
            }, 750);
        });
    },

    "timeline": function() { 
        if($('.timeline-container').length) {     
            // MATCH WINDOWS SIZE FUNCTION 
            function installMediaQueryWatcher(mediaQuery, layoutChangedCallback) {
                var mql = window.matchMedia(mediaQuery);
                mql.addListener(function (e) { return layoutChangedCallback(e.matches); });
                layoutChangedCallback(mql.matches);
            }

            // YEARS NAV - STICKY 
            var stickySidebar = $('.timeline-container').offset().top;

            if ($(window).scrollTop() > stickySidebar) {
                $('.timeline-header-container').addClass('affix');
            }

            $(window).scroll(function() {  
                if ($(window).scrollTop() > stickySidebar) {
                    $('.timeline-header-container').addClass('affix');
                }
                else {
                    $('.timeline-header-container').removeClass('affix');
                }
            });

            // YEARS NAV - ANIMATION (SMALL HEIGHT DESKTOP & NORMAL DESKTOP)
            installMediaQueryWatcher("(max-height:850px) and (min-width: 992px)", function(matches) {
                if (matches) {
                    document.querySelectorAll(".anchor").forEach(anchor => {
                        anchor.addEventListener("click", function(e) {
                            e.preventDefault();
                        
                            const targetElem = document.querySelector(e.target.getAttribute("href"));  

                            gsap.to(window, {
                                scrollTo: {
                                    y: targetElem,
                                    offsetY: 50,
                                    autoKill: false
                                },
                                duration: 1
                            });
                        });
                    });
                }  else {
                    document.querySelectorAll(".anchor").forEach(anchor => {
                        anchor.addEventListener("click", function(e) {
                            e.preventDefault();
                        
                            const targetElem = document.querySelector(e.target.getAttribute("href"));  

                            gsap.to(window, {
                                scrollTo: {
                                    y: targetElem,
                                    offsetY: 100,
                                    autoKill: false
                                },
                                duration: 1
                            });
                        });
                    });
                }
            });

            // YEARS NAV - ANIMATION (SMALL HEIGHT DESKTOP & DESKTOP)
            var mobileTimelineSelect = $(".mobile-timeline-nav select");

            function anchorMobilLinked() {
                var mobileTimelineSelectValue = $(mobileTimelineSelect).find('.active').val();
                $(mobileTimelineSelect).val(mobileTimelineSelectValue);
            }

            $(mobileTimelineSelect).on('keyup keypress blur change', function(){
                var mobileTimelineLink = $(this).find('option:selected').attr('href');

                gsap.to(window, {
                    scrollTo: {
                        y: mobileTimelineLink,
                        offsetY: 150,
                        autoKill: false
                    },
                    duration: 1
                });
            });
                
            // PANELS ANIMATION
            const panels = gsap.utils.toArray("#panels-container .panel");
            const panelsInner = gsap.utils.toArray("#panels-container .panel .panel-container");
            const panelsInnerVertical = gsap.utils.toArray("#panels-container .panel .panel-container-v");
            const panelsInnerHorizontal = gsap.utils.toArray("#panels-container .panel .panel-container-h");
            const panelsHorizontal = gsap.utils.toArray("#panels-container .panel-horizontal");
            const panelsHorizontalContainer = gsap.utils.toArray("#panels-container .horizontal");
        
            /// PANELS HORIZONTAL PIN
            panelsHorizontalContainer.forEach((sct, i) => {
                var panelsHorizontalCible = $(sct).find(".panel-horizontal");
                const panelsHorizontalCibleC = gsap.utils.toArray(panelsHorizontalCible);
            
                let maxWidth = 0;

                const getMaxWidth = () => {
                    maxWidth = 0;
                    panelsHorizontalCibleC.forEach((section) => {
                        maxWidth += section.offsetWidth;
                    });
                };

                getMaxWidth();
                ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

                panelsHorizontalCibleC.forEach((sct, i) => {
                    if($(sct).hasClass('panel-highlight')){                    
                        var cutedDateRight = sct.querySelector(".cuted-date");
                    }; 

                    function anchorLinked() {
                        $(".anchor").each(function() {                       
                            if($(this).attr('href') == $(sct).attr('data-link')) {
                                $(this).addClass('active');
                                $(".anchor-h").removeClass('active')
                            } else if ($(sct).attr('data-link') !== undefined) {
                                $(this).removeClass('active');
                            }
                        });

                        anchorMobilLinked();
                    }

                    let highlightBlockAnim = gsap.timeline({paused:true});

                    installMediaQueryWatcher("(min-width: 576px)", function(matches) {
                        if (matches) {
                            if ($(cutedDateRight).length) {
                                highlightBlockAnim.fromTo(cutedDateRight, {autoAlpha:0, x:-50}, {autoAlpha:1, x:0});
                            }
                        }
                    });
        
                    installMediaQueryWatcher("(min-width: 576px)", function(matches) {
                        if (matches) {
                            // PANELS HORIZONTAL ANIMATION (DESKTOP)
                            ScrollTrigger.create({
                                trigger: sct,
                                start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/2.5),
                                end: () => '+=' + (sct.offsetWidth - window.innerWidth/2),
                
                                onEnter: function() { 
                                    highlightBlockAnim.play();

                                    if($(sct).hasClass('panel-highlight')){ 
                                    gsap.to('.timeline-container', {backgroundColor: '#00274f'});
                                    }  
                                },
                                onLeave: function() {
                                    highlightBlockAnim.reverse();

                                    if($(sct).hasClass('panel-alone')){
                                        gsap.to('.timeline-container', {backgroundColor: '#e8ebef'});
                                    }      
                                },
                                onEnterBack: function() {
                                    highlightBlockAnim.play();
                                    anchorLinked();
                                    if($(sct).hasClass('panel-alone')){
                                        gsap.to('.timeline-container', {backgroundColor: '#00274f'});
                                    }    
                                },
                                onLeaveBack: function() {
                                    highlightBlockAnim.reverse();

                                    if($(sct).hasClass('panel-highlight') && !$(sct).hasClass('panel-highlight-second')){
                                        gsap.to('.timeline-container', {backgroundColor: '#e8ebef'});
                                    }     
                                },
                            });
                        } else {
                            // PANELS HORIZONTAL ANIMATION (MOBIL)
                            ScrollTrigger.create({
                                trigger: sct,
                                start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/2.5),
                                end: () => '+=' + (sct.offsetWidth - window.innerWidth/2),
                
                                onEnter: function() { 
                                    highlightBlockAnim.play();

                                    if($(sct).hasClass('panel-highlight')){ 
                                        gsap.to('.timeline-container', {backgroundColor: '#00274f'});
                                    }  
                                },
                                onLeave: function() {
                                    highlightBlockAnim.reverse();

                                    if($(sct).hasClass('panel-alone')){
                                        gsap.to('.timeline-container', {backgroundColor: '#e8ebef'});
                                    }      
                                },
                                onEnterBack: function() {
                                    highlightBlockAnim.play();
                                    anchorLinked();
                                    if($(sct).hasClass('panel-alone')){
                                        gsap.to('.timeline-container', {backgroundColor: '#00274f'});
                                    }    
                                },
                                onLeaveBack: function() {
                                    highlightBlockAnim.reverse();

                                    if($(sct).hasClass('panel-highlight') && !$(sct).hasClass('panel-highlight-second')){
                                        gsap.to('.timeline-container', {backgroundColor: '#e8ebef'});
                                    }     
                                },
                            });
                        }
                    });
                    
                });
                
                /// PANELS HORIZONTAL PIN (SMALL HEIGHT DESKTOP)
                installMediaQueryWatcher("(max-height:849.98px) and (min-width: 992px)", function(matches) {
                    if (matches) {
                        gsap.to(panelsHorizontalCibleC, {  
                            xPercent: -100,
                            ease: "none",
                            scrollTrigger: {
                                trigger: sct,
                                pin: true,
                                start: "top top+=170px",
                                end: () => "+=" + (sct.offsetWidth - innerWidth),
                                scrub: true,
                            }
                        });
                    }
                });
                
                /// PANELS HORIZONTAL PIN (DESKTOP)
                installMediaQueryWatcher("(min-height:850px) and (min-width: 576px)", function(matches) {
                    if (matches) {
                        gsap.to(panelsHorizontalCibleC, {  
                            xPercent: -100,
                            ease: "none",
                            scrollTrigger: {
                                trigger: sct,
                                pin: true,
                                start: "top top+=270px",
                                end: () => "+=" + (sct.offsetWidth - innerWidth),
                                scrub: true,
                            }
                        });
                    }
                });
            });
            
            /// PANEL INSIDE ANIMATION
            panelsInner.forEach((sct) => {
                /// NAV SWITCH ANIMATION
                function anchorLinked() {
                    $(".anchor").each(function() {                       
                        if($(this).attr('href') == $(sct).attr('data-link')) {
                            $(this).addClass('active');
                            $(".anchor-h").removeClass('active');
                        } else if ($(sct).attr('data-link') !== undefined) {
                            $(this).removeClass('active');
                        }
                    });

                    anchorMobilLinked();
                }

                /// PANELS TIMELINE VAR
                var bigDate = sct.querySelector(".big-date h3");
                var cutedDate = sct.querySelector(".cut-date .cuted-date");
                var multiColumnFirstImg = sct.querySelector(".column-pics img.first-pic");
                var multiColumnSecondImg = sct.querySelector(".column-pics img.second-pic");
                var multiHorseFirstImg = sct.querySelector(".horse-pics img.first-pic");
                var multiHorseSecondImg = sct.querySelector(".horse-pics img.second-pic");
                var multiDesc = sct.querySelector(".multi-pics .img-with-d p");
                var oneImg = sct.querySelector(".one-pic img");
                var oneRightDesc = sct.querySelector(".one-description .left-img-with-d p");
                var oneLeftDesc = sct.querySelector(".one-description .right-img-with-d p");
                var oneBottomDesc = sct.querySelector(".one-description .top-img-with-d p");

                let relatedBlockAnim = gsap.timeline({paused:true});
                relatedBlockAnim.addPause();
                relatedBlockAnim.addLabel("begin");

                installMediaQueryWatcher("(min-width: 576px)", function(matches) {
                    if (matches) {
                        // PANELS TIMELINE INIT (DESKTOP)
                        if ($(bigDate).length ) {
                            relatedBlockAnim.fromTo(bigDate, {autoAlpha:0, y:100}, {autoAlpha:1, y:0});
                        }
                        if($(cutedDate).length && $(cutedDate).hasClass('bottom-cuted-date')) {
                            relatedBlockAnim.fromTo(cutedDate, {autoAlpha:0}, {autoAlpha:1});
                        }
                        if ($(multiColumnSecondImg).length ) {
                            relatedBlockAnim.fromTo(multiColumnSecondImg, {autoAlpha:0, y:100}, {autoAlpha:1, y:0});
                            relatedBlockAnim.fromTo(multiColumnFirstImg, {autoAlpha:0, y:100}, {autoAlpha:1,  y:0});
                        }
                        if ($(multiHorseSecondImg).length ) {
                            relatedBlockAnim.fromTo(multiHorseSecondImg, {autoAlpha:0, y:100}, {autoAlpha:1, y:0});
                            relatedBlockAnim.fromTo(multiHorseFirstImg, {autoAlpha:0, x:50}, {autoAlpha:1,  x:0});
                        }
                        if ($(multiDesc).length ) {
                            relatedBlockAnim.fromTo(multiDesc, {autoAlpha:0, y:-100}, {autoAlpha:1,  y:0});
                        }
                        if($(oneImg).length && !$(sct).hasClass('panel-highlight')) {
                            relatedBlockAnim.fromTo(oneImg, {autoAlpha:0, y:100}, {autoAlpha:1,  y:0});
                        }
                        if ($(oneRightDesc).length ) {
                            relatedBlockAnim.fromTo(oneRightDesc, {autoAlpha:0, x:-100}, {autoAlpha:1, x:0});
                        }
                        if ($(oneLeftDesc).length ) {
                            relatedBlockAnim.fromTo(oneLeftDesc, {autoAlpha:0, x:100}, {autoAlpha:1, x:0});
                        }
                        if ($(oneBottomDesc).length ) {
                            relatedBlockAnim.fromTo(oneBottomDesc, {autoAlpha:0, y:-100}, {autoAlpha:1, y:0});
                        }
                        if($(cutedDate).length && $(sct).hasClass('special-highlight')) {
                            relatedBlockAnim.from(cutedDate, {autoAlpha:0});
                        }
                        else if($(cutedDate).length && !$(cutedDate).hasClass('bottom-cuted-date') && !$(sct).hasClass('panel-highlight')) {
                            relatedBlockAnim.fromTo(cutedDate, {autoAlpha:0}, {autoAlpha:1});
                        }
                    } else {
                        // PANELS TIMELINE INIT (MOBIL)
                        if ($(bigDate).length ) {
                            relatedBlockAnim.fromTo(bigDate, {autoAlpha:0, y:100}, {autoAlpha:1, y:0});
                        }
                        if($(cutedDate).length && $(cutedDate).hasClass('bottom-cuted-date')) {
                            relatedBlockAnim.fromTo(cutedDate, {autoAlpha:0}, {autoAlpha:1});
                        }

                        if($(cutedDate).length && $(sct).hasClass('special-highlight')) {
                            relatedBlockAnim.from(cutedDate, {autoAlpha:0});
                        }

                        else if($(cutedDate).length && !$(cutedDate).hasClass('bottom-cuted-date') && !$(sct).hasClass('panel-highlight')) {
                            relatedBlockAnim.fromTo(cutedDate, {autoAlpha:0}, {autoAlpha:1});
                        }

                        if ($(oneLeftDesc).length ) {
                            relatedBlockAnim.fromTo(oneLeftDesc, {autoAlpha:0, x:100}, {autoAlpha:1, x:0});
                        }

                        if ($(multiColumnSecondImg).length ) {
                            relatedBlockAnim.fromTo(multiColumnFirstImg, {autoAlpha:0, y:100}, {autoAlpha:1,  y:0});
                            relatedBlockAnim.fromTo(multiColumnSecondImg, {autoAlpha:0, y:100}, {autoAlpha:1, y:0});
                        }

                        if ($(multiHorseSecondImg).length ) {
                            relatedBlockAnim.fromTo(multiHorseFirstImg, {autoAlpha:0, x:50}, {autoAlpha:1,  x:0});
                            relatedBlockAnim.fromTo(multiHorseSecondImg, {autoAlpha:0, y:100}, {autoAlpha:1, y:0});
                        }

                        if ($(multiDesc).length ) {
                            relatedBlockAnim.fromTo(multiDesc, {autoAlpha:0, y:-100}, {autoAlpha:1,  y:0});
                        }

                        if($(oneImg).length && !$(sct).hasClass('panel-highlight')) {
                            relatedBlockAnim.fromTo(oneImg, {autoAlpha:0, y:100}, {autoAlpha:1,  y:0});
                        }

                        if ($(oneRightDesc).length ) {
                            relatedBlockAnim.fromTo(oneRightDesc, {autoAlpha:0, x:-100}, {autoAlpha:1, x:0});
                        }

                        if ($(oneBottomDesc).length ) {
                            relatedBlockAnim.fromTo(oneBottomDesc, {autoAlpha:0, y:-100}, {autoAlpha:1, y:0});
                        }
                    }
                });
                relatedBlockAnim.addPause();

                relatedBlockAnim.addLabel("topRight");
                if($(sct).hasClass('panel-container-v')) {
                    relatedBlockAnim.to(sct, {autoAlpha:0});
                }   
                relatedBlockAnim.addPause();

                relatedBlockAnim.addLabel("center");
                relatedBlockAnim.to(sct, {autoAlpha:1});
                relatedBlockAnim.addPause();

                relatedBlockAnim.addLabel("bottomLeft");
                if($(sct).hasClass('panel-container-v')) {
                    relatedBlockAnim.to(sct, {autoAlpha:0});
                }
                relatedBlockAnim.addPause();
                
                /// FIRST PANEL ANIMATION
                if($(sct).hasClass('first-panel')){
                    installMediaQueryWatcher("(max-height:849.98px) and (min-width: 992px)", function(matches) {
                        if (matches) {
                             /// (SMALL HEIGHT DESKTOP)
                             ScrollTrigger.create({
                                trigger: sct,
                                pin:true,
                                start: () => 'top top+=100px',
                                end: () => 'bottom center',
                                onEnter: function() {    
                                    anchorLinked();
                                    relatedBlockAnim.play('begin');
                                },
                                onLeave: function() {
                                    relatedBlockAnim.play('topRight');
                                },
                                onEnterBack: function() {
                                    anchorLinked();
                                    relatedBlockAnim.play('center');
                                },
                                onLeaveBack: function() {
                                    relatedBlockAnim.play('bottomLeft');
                                },
                            });
                        } else {
                            /// (NORMAL DESKTOP)

                            ScrollTrigger.create({
                                trigger: sct,
                                pin:true,
                                start: () => 'top top+=200px',
                                end: () => 'bottom center',
                                onEnter: function() {    
                                    anchorLinked();
                                    relatedBlockAnim.play('begin');
                                },
                                onLeave: function() {
                                    relatedBlockAnim.play('topRight');
                                },
                                onEnterBack: function() {
                                    anchorLinked();
                                    relatedBlockAnim.play('center');
                                },
                                onLeaveBack: function() {
                                    relatedBlockAnim.play('bottomLeft');
                                },
                            });
                        }
                    });
                } 
                /// LAST PANEL ANIMATION
                else if($(sct).hasClass('last-panel')) {
                    ScrollTrigger.create({
                        trigger: sct,
                        start: () => 'top bottom-=470px',
                        end: () => 'bottom center',
                        onEnter: function() {
                            relatedBlockAnim.play('begin');
                            anchorLinked();
                        },
                        onLeave: function() {
                            relatedBlockAnim.play('topRight');
                        },
                        onEnterBack: function() {
                            relatedBlockAnim.play('center');
                            anchorLinked();
                        },
                        onLeaveBack: function() {
                            relatedBlockAnim.play('bottomLeft');
                        },
                    });
                }
                /// PANELS HORIZONTAL ANIMATION
                else if($(sct).hasClass('panel-inner-h')) {
                    ScrollTrigger.create({
                        trigger: sct,
                        
                        //end: () => 'bottom bottom',
                        start: () => 'bottom bottom',

                        //start: () => 'top center',
                        end: () => 'bottom top',
                        onEnter: function() {
                            relatedBlockAnim.play('begin');
                            anchorLinked();
                        },
                        onLeave: function() {
                            installMediaQueryWatcher("(min-width: 576px)", function(matches) {
                                if (matches){
                                    if($(sct).hasClass('panel-alone') ) {
                                        gsap.to('.timeline-container', {backgroundColor: '#e8ebef'});
                                    }     
                                }
                            });
                            relatedBlockAnim.play('topRight');
                        },
                        onEnterBack: function() {
                            relatedBlockAnim.play('center');
                            anchorLinked();
                            
                            installMediaQueryWatcher("(min-width: 576px)", function(matches) {
                                if (matches){
                                    if($(sct).hasClass('panel-alone') ) {
                                        gsap.to('.timeline-container', {backgroundColor: '#00274f'});
                                    }     
                                }
                            }); 
                        },
                        onLeaveBack: function() {
                            relatedBlockAnim.play('bottomLeft');
                        },
                    }); 
                }
                /// NORMAL PANEL ANIMATION
                else {
                    installMediaQueryWatcher("(max-height:849.98px) and (min-width: 992px)", function(matches) {
                        if (matches) {
                             /// PANELS VERTICAL PIN (SMALL HEIGHT DESKTOP)
                            ScrollTrigger.create({
                                trigger: sct,
                                pin: true,   
                        
                                start: () => 'top top+=50px',
                                //start: () => 'top center',
                                end: () => 'bottom center',
                                onEnter: function() {
                                    relatedBlockAnim.play('begin');
                                    anchorLinked();
                                },
                                onLeave: function() {
                                    if($(sct).hasClass('panel-alone') ) {
                                        gsap.to('.timeline-container', {backgroundColor: '#e8ebef'});
                                    }     
                                    relatedBlockAnim.play('topRight');
                                },
                                onEnterBack: function() {
                                    relatedBlockAnim.play('center');
                                    anchorLinked();
        
                                    if($(sct).hasClass('panel-alone') ) {
                                        gsap.to('.timeline-container', {backgroundColor: '#00274f'});
                                    }      
                                },
                                onLeaveBack: function() {
                                    relatedBlockAnim.play('bottomLeft');
                                },
                            });
                        } else {
                            /// PANELS VERTICAL PIN (NORMAL DESKTOP)

                            ScrollTrigger.create({
                                trigger: sct,
                                pin: true,
                                start: () => 'top top+=200px',
                                end: () => 'bottom top+=450px',
                                //start: () => 'top center',
                                //end: () => 'bottom center',
                                onEnter: function() {
                                    relatedBlockAnim.play('begin');
                                    anchorLinked();
                                },
                                onLeave: function() {
                                    if($(sct).hasClass('panel-alone') ) {
                                        gsap.to('.timeline-container', {backgroundColor: '#e8ebef'});
                                    }     
                                    relatedBlockAnim.play('topRight');
                                },
                                onEnterBack: function() {
                                    relatedBlockAnim.play('center');
                                    anchorLinked();
        
                                    if($(sct).hasClass('panel-alone') ) {
                                        gsap.to('.timeline-container', {backgroundColor: '#00274f'});
                                    }      
                                },
                                onLeaveBack: function() {
                                    relatedBlockAnim.play('bottomLeft');
                                },
                            });
                        }
                    });
                    
                }
            });
        }
    },

    "initMapHandler": function() {
        if($('#map').length) {
            let script = document.createElement('script');
            let map;

            script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBggyxEobWG_ROnG-QVGugmcHFOYlHCg7U&callback=initMap';
            script.defer = true;

            window.initMap = function() {
                const restaurant = { lat: 49.603996, lng: 6.131322 };
                // The map, centered at Uluru
                map = new google.maps.Map(document.getElementById("map"), {
                    zoom: 17,
                    center: restaurant,
                });

                // The marker, positioned at Uluru
                const marker = new google.maps.Marker({
                    position: restaurant,
                    map: map,
                    icon: '/wp-content/themes/intrepide/static/img/pin.png'
                });

                const styledMapType = new google.maps.StyledMapType(
                    [
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#e9e9e9"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 29
                                },
                                {
                                    "weight": 0.2
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 18
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                },
                                {
                                    "lightness": 21
                                }
                            ]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#dedede"
                                },
                                {
                                    "lightness": 21
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "saturation": 36
                                },
                                {
                                    "color": "#333333"
                                },
                                {
                                    "lightness": 40
                                }
                            ]
                        },
                        {
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f2f2f2"
                                },
                                {
                                    "lightness": 19
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#fefefe"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#fefefe"
                                },
                                {
                                    "lightness": 17
                                },
                                {
                                    "weight": 1.2
                                }
                            ]
                        }
                    ]
                );

                map.mapTypes.set("styled_map", styledMapType);
                map.setMapTypeId("styled_map");
            };

            document.head.appendChild(script);
        }
    },
    
};


export default general;

(function($){
    $(document).ready(function () {
        general.videoPlayer();
        general.homeLoader();
        general.menuHandler();
        general.showAnim();
        general.folioTabs();
        general.sliderHandler();
        general.scrollToAnimation();
        general.timeline();
        general.initMapHandler();
    });

    $(window).resize(function(){
        general.folioTabs();
    });
})($);

$(window).on('load', function() {
    // PORTFOLIO TAB CONTENT HEIGHT CALCUL
    var activeTabHeight = $('.tab-panel.active').height();
    $('.portfolio-tabcontent:not(.-slider)').css('min-height', activeTabHeight + 'px');

    ScrollTrigger.create({
        trigger: '.swiper-home',
        start: () => 'top bottom-=400px',
    });

    if($('.single-portfolio').length) {
        gsap.fromTo('.related-portfolio', {autoAlpha: 0, y: 20,}, {autoAlpha: 1, y:0, duration: .3});
        gsap.to('.single-portfolio .footer', {autoAlpha: 1, duration: 0});
    }
});

